var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embed-responsive embed-responsive-custom",style:({ '--embed': (_vm.embed.height || 1) / (_vm.embed.width || 1) })},[_c('div',{staticClass:"embed-responsive-item"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }